import { render, staticRenderFns } from "./Sigs.vue?vue&type=template&id=4862cb5a&"
import script from "./Sigs.vue?vue&type=script&lang=js&"
export * from "./Sigs.vue?vue&type=script&lang=js&"
import style0 from "./Sigs.vue?vue&type=style&index=0&id=4862cb5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports